<template>
  <div class="gift-menu">
    <h1 class="gift-menu-title">
      Lista de Presentes
      <BaseSaving :show="saving" ref="saving" @closed="setSaving(false)" />
    </h1>
    <div class="gift-menu-buttons" ref="scrollMenu">
      <a
        v-for="item in menuItems"
        :key="item.tab"
        @click="changeTab(item.tab)"
        :class="{ active: giftsTab === item.tab }"
        class="gift-menu-button"
      >
        <div class="icon">
          <base-icon width="16" height="16" :name="item.icon" />
        </div>
        <span class="title-not-formatted">{{ item.title }}</span>
        <span class="title-formatted" v-html="item.titleFormatted"></span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseSaving from '../BaseSaving.vue'

export default {
  name: 'GiftMenu',

  components: {
    BaseSaving,
  },

  computed: {
    saving() {
      return this.$store.state.gifts.saving
    },
    tabContainerScrollLeft() {
      return this.$store.state.gifts.tabContainerScrollLeft
    },
    giftsTab: {
      get() {
        return this.$store.state.gifts.tab
      },
      set(payload) {
        this.$store.dispatch('gifts/setGiftsTab', payload)
      },
    },

    firstTab() {
      return this.menuItems[0].tab
    },
  },

  watch: {
    saving(newValue) {
      if (newValue) this.$refs.saving.toggle()
    },
  },

  data() {
    return {
      menuItems: [
        {
          title: 'Editar minha lista',
          titleFormatted: 'Editar<br>minha lista',
          tab: 'editar-lista',
          icon: 'painel/icon-edit-list',
        },
        {
          title: 'Presentes recebidos',
          titleFormatted: 'Presentes<br>recebidos',
          tab: 'recebidos',
          icon: 'painel/icon-gift-received',
        },
        {
          title: 'Configurar lista',
          titleFormatted: 'Configurar<br>lista',
          tab: 'configurar-lista',
          icon: 'painel/icon-config-list',
        },
        {
          title: 'Incluir lista externa',
          titleFormatted: 'Incluir<br>lista externa',
          tab: 'listas-externas',
          icon: 'painel/icon-extern-list',
        },
        {
          title: 'Sobre a lista',
          titleFormatted: 'Sobre<br>a lista',
          tab: 'sobre-a-lista',
          icon: 'painel/icon-about-list',
        },
      ],
    }
  },

  mounted() {
    this.$refs.scrollMenu.scrollLeft = this.tabContainerScrollLeft
  },

  methods: {
    ...mapActions({
      setSaving: 'gifts/setSaving',
      setTabContainerScrollLeft: 'gifts/setTabContainerScrollLeft',
    }),

    changeTab: function (tab) {
      this.setTabContainerScrollLeft(this.$refs.scrollMenu.scrollLeft)
      if (!window.location.href.includes(tab)) {
        this.$router.replace(`/presentes/${tab ?? this.firstTab}`).then(() => {
          this.vibrate()
          if (tab) this.giftsTab = tab
          this.$emit('input', this.giftsTab ?? this.firstTab)
        })
      }
    },

    vibrate() {
      if (navigator && navigator.vibrate) {
        window.navigator.vibrate(40)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.gift-menu-title {
  display: flex;
  justify-content: space-between;
  padding: 56px 0 19px 8px;
  font-size: 24px;
  font-weight: 700;
  color: $neutraldarkest;
  text-align: left;
}
.gift-menu-buttons {
  display: flex;
  flex-direction: row;
  overflow: auto;
  align-items: center;
  scrollbar-width: none;
  height: 115px;
  &::-webkit-scrollbar {
    width: 0 !important;
  }
  @media screen and (min-width: 1280px) {
    height: 72px;
    padding: 8px;
    border-radius: 16px;
    background-color: $neutrallightest;
  }
}

.gift-menu-button {
  display: flex;
  min-width: 116px;
  height: 92px;
  padding: 0 13px;
  margin: 0 8px;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  color: $neutral;
  text-align: left;
  line-height: 16px;
  border-radius: 16px;
  border: 1.5px solid #dbe4ed;
  transition: 0.05s all;
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }

  .title-not-formatted {
    display: none;
  }

  @media screen and (min-width: 744px) {
    flex: 1;
  }
  @media screen and (min-width: 1280px) {
    flex-direction: row;
    align-items: center;
    border-color: transparent;
    line-height: 1;
    height: 56px;

    &:not(.active):hover {
      border-color: #dbe4ed;
      background-color: #fff;
    }

    .title-not-formatted {
      display: inline;
    }
    .title-formatted {
      display: none;
    }
  }
  @media screen and (min-width: 1920px) {
    font-size: 16px;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 20px;
    color: $neutral;
    background-color: $neutrallightest;
    @media screen and (min-width: 1280px) {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 1280px) {
    &:hover,
    &.active {
      height: 100px;
    }
  }

  &.active {
    color: #fff;
    border-color: #3dafb0;
    background-color: #3dafb0;

    .icon {
      color: #fff;
      background-color: #0f9596;
    }
  }
}
</style>
